import { TabItem, PillItem } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

import { text as textUtils } from 'shared/utils/text.util';

export enum TabGroupIds {
  CESSION_TO_FUND = 'CESSION_TO_FUND'
}

export interface TabGroupConfig {
  cession: TabItem<TabGroupIds>[];
}

export const TABS_GROUPS_CONFIG: TabGroupConfig = {
  cession: [
    {
      id: TabGroupIds.CESSION_TO_FUND,
      title: textUtils.firstLetterUppercase(i18next.t('assignmentToFund'))
    }
  ]
};

export enum PillGroupIds {
  NEXT_CESSION = 'NEXT_CESSION',
  SENT_TO_FOUND = 'SENT_TO_FOUND',
  RECEIVED_BY_FUND = 'RECEIVED_BY_FUND',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  REJECTED_APPROVAL = 'REJECTED_APPROVAL',
  CESSION_ASSIGNED = 'CESSION_ASSIGNED'
}

export type PillGroupConfig = { [key in TabGroupIds]: PillItem<PillGroupIds>[] };

export const PILLS_GROUP_CONFIG: PillGroupConfig = {
  [TabGroupIds.CESSION_TO_FUND]: [
    { id: PillGroupIds.NEXT_CESSION, text: textUtils.firstLetterUppercase(i18next.t('nextCession')) },
    { id: PillGroupIds.SENT_TO_FOUND, text: textUtils.firstLetterUppercase(i18next.t('sentToFund')) },
    { id: PillGroupIds.RECEIVED_BY_FUND, text: textUtils.firstLetterUppercase(i18next.t('awaitingFundInformation')) },
    { id: PillGroupIds.AWAITING_APPROVAL, text: textUtils.firstLetterUppercase(i18next.t('awaitingApproval')) },
    { id: PillGroupIds.REJECTED_APPROVAL, text: textUtils.firstLetterUppercase(i18next.t('rejectedApproval')) },
    { id: PillGroupIds.CESSION_ASSIGNED, text: textUtils.firstLetterUppercase(i18next.t('submittedCession')) }
  ]
};
